(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sl-story"] && !Shopify.designMode) return;
  try {
    
/* lightweight reveal — no heavy animation library, surge-safe */
(function(){
  if(matchMedia('(prefers-reduced-motion:reduce)').matches){
    document.querySelectorAll('.r').forEach(function(e){e.classList.add('in')});
  } else {
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.r').forEach(function(e){io.observe(e)});
  }

  /* reading progress bar */
  var bar=document.getElementById('progress');
  var ticking=false;
  function updateProgress(){
    var h=document.documentElement;
    var max=h.scrollHeight-h.clientHeight;
    var pct=max>0?(h.scrollTop/max)*100:0;
    if(bar)bar.style.width=pct+'%';
    ticking=false;
  }
  /* sticky CTA: show after hero scrolled past, hide near the join section
     (no point nagging once they have reached the real CTA), dismissible for session */
  var cta=document.getElementById('stickyCta');
  var dismissed=false;
  try{dismissed=sessionStorage.getItem('slCtaDismissed')==='1'}catch(e){}
  var hero=document.querySelector('.hero');
  var join=document.getElementById('join');
  function updateCta(){
    if(!cta||dismissed){return}
    var heroBottom=hero?hero.offsetHeight:600;
    var y=window.scrollY||document.documentElement.scrollTop;
    var pastHero=y>heroBottom*0.9;
    var atJoin=false;
    if(join){var jr=join.getBoundingClientRect();atJoin=jr.top<window.innerHeight&&jr.bottom>0}
    if(pastHero && !atJoin){cta.classList.add('show')}else{cta.classList.remove('show')}
  }
  var closeBtn=document.getElementById('stickyClose');
  if(closeBtn){closeBtn.addEventListener('click',function(){
    dismissed=true;cta.classList.remove('show');
    try{sessionStorage.setItem('slCtaDismissed','1')}catch(e){}
  })}
  window.addEventListener('scroll',function(){
    if(!ticking){window.requestAnimationFrame(function(){updateProgress();updateCta()});ticking=true}
  },{passive:true});
  updateProgress();updateCta();
})();

  } catch(e) { console.error(e); }
})();
})();
